import React, { FC } from "react"

interface PaginationProps {
  currentPage?: number
  totalPages?: number
  perPage?: number
  totalCount?: number
  onPageChange?: (page: number) => void
}

const Pagination: FC<PaginationProps> = ({
  currentPage = 1,
  totalPages = 1,
  perPage = 10,
  totalCount = 0,
  onPageChange
}) => {
  const pages: number[] = []
  for (let i = 1; i <= totalPages; i++) {
    pages.push(i)
  }

  return (
    <div className="flex justify-center mt-8">
      <div className="flex gap-2 items-center">
        <button
          className="px-3 py-2 border border-gray-200 bg-white rounded-lg cursor-pointer transition-all text-sm min-w-[2.5rem] h-10 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-primary-light/10 hover:border-primary disabled:hover:bg-white disabled:hover:border-gray-200"
          onClick={() => onPageChange?.(currentPage - 1)}
          disabled={currentPage === 1}
        >
          前へ
        </button>
        
        {pages.map((page) => (
          <button
            key={page}
            className={`px-3 py-2 border rounded-lg cursor-pointer transition-all text-sm min-w-[2.5rem] h-10 ${
              page === currentPage
                ? 'bg-primary text-white border-primary'
                : 'border-gray-200 bg-white hover:bg-primary-light/10 hover:border-primary'
            }`}
            onClick={() => onPageChange?.(page)}
          >
            {page}
          </button>
        ))}
        
        <button
          className="px-3 py-2 border border-gray-200 bg-white rounded-lg cursor-pointer transition-all text-sm min-w-[2.5rem] h-10 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-primary-light/10 hover:border-primary disabled:hover:bg-white disabled:hover:border-gray-200"
          onClick={() => onPageChange?.(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          次へ
        </button>
      </div>
    </div>
  )
}

export default Pagination

